import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const WelcomeOfferBanner = () => {
    const [offer, setOffer] = useState(null);
    const [isVisible, setIsVisible] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Check if banner was dismissed in this session
        const dismissed = sessionStorage.getItem('welcomeBannerDismissed');
        if (dismissed === 'true') {
            setIsVisible(false);
            setIsLoading(false);
            return;
        }

        // Fetch current welcome offer
        const fetchOffer = async () => {
            try {
                const response = await fetch('/api/promocodes/welcome-offer');
                const data = await response.json();

                if (data.code) {
                    setOffer(data);
                }
            } catch (error) {
                console.error('Error fetching welcome offer:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchOffer();
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        sessionStorage.setItem('welcomeBannerDismissed', 'true');
    };

    // Don't render if loading, not visible, or no offer
    if (isLoading || !isVisible || !offer) {
        return null;
    }

    // Generate offer text based on promo type
    const getOfferText = () => {
        // Use description if available, otherwise fall back to auto-generated text
        if (offer.description && offer.description.trim() !== '') {
            return offer.description;
        }

        // Fallback (if description is empty)
        if (offer.type === 'fixed') {
            return `Get £${offer.value} off`;
        } else if (offer.type === 'percentage') {
            return `Get ${offer.value}% off`;
        } else if (offer.type === 'free_shipping') {
            return `Get FREE DELIVERY`;
        }
        return 'Special offer';
    };

    return (
        <>
            <style>{`
                .welcome-banner {
                    // background-color: #ffffff;
                    background-color: transparent;
                    color: #000000;
                    padding: 10px 20px;
                    text-align: center;
                    position: relative;
                    // box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    //z-index: 1000;
                    // border-top: 2px solid #3E6D9C;
                    // border-bottom: 2px solid #FD7014;
                    width: 100%;
                    margin: 0;
                }
                
                .welcome-banner-content {
                    width: 100%;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                }
                
                .welcome-banner-text {
                    font-size: 15px;
                    font-weight: bold;
                    line-height: 1.5;
                    padding-right: 35px;
                }
                
                .welcome-banner-code {
                    background-color: #FD7014;
                    color: white;
                    padding: 4px 12px;
                    border-radius: 4px;
                    font-weight: bold;
                    margin: 0 6px;
                    display: inline-block;
                }
                
                .welcome-banner-link {
                    color: #FD7014;
                    text-decoration: underline;
                    font-weight: bold;
                    margin-left: 8px;
                }
                
                .welcome-banner-close {
                    position: absolute;
                    right: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: transparent;
                    border: none;
                    color: #666666;
                    cursor: pointer;
                    padding: 4px;
                    display: flex;
                    align-items: center;
                    opacity: 0.8;
                }
                
                .welcome-banner-close:hover {
                    opacity: 1;
                }
                
                /* Mobile responsive */
                @media (max-width: 768px) {
                    .welcome-banner {
                        padding: 6px 12px;
                    }
                    
                    .welcome-banner-text {
                        font-size: 12px;
                        line-height: 1.4;
                        padding-right: 30px;
                    }
                    
                    .welcome-banner-code {
                        padding: 2px 8px;
                        font-size: 11px;
                        margin: 0 4px;
                    }
                    
                    .welcome-banner-link {
                        font-size: 12px;
                        margin-left: 4px;
                    }
                    
                    .welcome-banner-close {
                        right: 4px;
                    }
                }
            `}</style>

            <div className="welcome-banner">
                <div className="welcome-banner-content">
                    <span className="welcome-banner-text">
                        {getOfferText()}! - Use code
                        <span className="welcome-banner-code">{offer.code}</span>
                        <Link to="/register" className="welcome-banner-link">
                            Register Now
                        </Link>
                    </span>

                    <button
                        onClick={handleDismiss}
                        className="welcome-banner-close"
                        aria-label="Dismiss banner"
                    >
                        <FaTimes size={16} />
                    </button>
                </div>
            </div>
        </>
    );
};

export default WelcomeOfferBanner;